<h1>Section Configuration</h1>
@for (sectionConfig of sectionConfigs$ | async; track sectionConfig.id) {
  <div class="section-config">
    <section [sectionConfig]="sectionConfig"></section>
  </div>
}
